export default "__VITE_PUBLIC_ASSET__990c36c7__"